import { css } from "lit";

export const styles = css`
  :host {
    --column-width: 508px; /* Maximum width for each column */

    display: flex;
    flex: 1 0 0%;
    height: 100%;
    min-height: 0;
  }

  .container {
    display: flex;
    flex-direction: column;
    padding: var(--sds-size-space-600);
    gap: var(--sds-size-space-600);
    box-sizing: border-box;
    max-width: calc(var(--column-width) + var(--sds-size-space-600) * 2);
    flex: 1 0 0%;
    height: 100%;
    overflow: hidden;
  }

  .container.two-columns {
    max-width: calc(var(--column-width) * 2 + var(--sds-size-space-600) * 3);
  }

  @media (max-width: 768px) {
    .two-columns {
      overflow: auto;
    }
  }

  /* Primary variant - styled like worlds-layout .main */
  .container.primary {
    border-radius: var(--sds-size-radius-600); /* 8px */
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
  }

  /* Secondary variant - styled like worlds-layout .secondary */
  .container.secondary {
    border-radius: var(--sds-size-radius-600); /* 8px */
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: transparent;
  }

  /* Ensure slotted content takes full width within columns */
  ::slotted([slot="column"]) {
    max-width: 508px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
  }

  @media (min-width: 768px) {
    .container {
      flex-direction: row;
    }

    ::slotted([slot="column"]) {
      min-height: unset;
      flex: 1;
    }
  }

  /* Respect user motion preferences */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

/**
 * Exported utility style for making content scrollable within content-container columns
 * Apply this to elements that need to scroll within their column container
 */
export const scrollableColumnStyles = css`
  .scrollable-column-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden auto;
  }
`;
